module.exports = __webpack_public_path__ + "static/img/exclusive-person.5344939.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exclusive-person.png
// module id = Oh18
// module chunks = 1